<template>
  <q-dialog
    ref="dialog"
    :maximized="$q.platform.is.mobile"
    @hide="onDialogHide"
  >
    <q-card class="q-dialog-plugin recover-activities-dialog">
      <q-card-section class="row">
        <div
          class="text-h6"
        >
          {{ $t('sessionActivityReports.restoreErrorTitle') }}
        </div>
        <q-space />
        <q-btn
          v-close-popup
          flat
          round
          dense
          icon="close"
        />
      </q-card-section>
      <q-card-section>
        <banner
          :message="$t('sessionActivityReports.errorRestoringActivities')"
        />
      </q-card-section>
      <q-card-section>
        <div>{{ $t('sessionActivityReports.restoreErrorTableInfo') }}</div>
        <session-activities-table
          :default-columns="[
            'status', 'client', 'startTimestamp','endTimestamp', 'duration', 'userName','type', 'sessionName', 'id'
          ]"
          disable-export
          disable-export-with-data
          disable-views
          disable-send-to-integration
          hide-bulk-actions
          hide-pagination-label
          is-deleted-list
          bordered
          selection="none"
          :failed-activity-ids="failedActivityIds"
        />
      </q-card-section>
      <q-card-actions>
        <q-field
          outlined
          dense
          readonly
          class="q-ml-sm q-mb-sm"
        >
          <template #control>
            <div
              class="self-center full-width no-outline cursor-pointer text-grey-6"
              @click="onCopyActivitiesIds"
            >
              {{ $t('sessionActivityReports.copyActivityIds') }}
            </div>
          </template>
          <template #append>
            <q-icon
              name="content_copy"
              class="cursor-pointer q-ml-xs text-grey-6"
              @click="onCopyActivitiesIds"
            />
          </template>
        </q-field>
        <q-space />
        <q-btn
          type="submit"
          flat
          color="primary"
          :label="$t('common.buttonOk')"
          @click="onOk"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { Clipboard } from '@capacitor/clipboard';
import Banner from 'components/UI/Banner';
import { copyToClipboard } from 'quasar';
import { notifySuccess } from 'src/composables/interactions';
import { defineAsyncComponent } from 'vue';

export default {
  name: 'FailedSessionActivitiesList',

  components: {
    Banner,
    SessionActivitiesTable: defineAsyncComponent(() => import('components/Sessions/SessionActivitiesTable.vue')),
  },

  props: {
    failedActivityIds: {
      type: Array,
      default: () => ([]),
    },
  },

  emits: ['hide', 'ok'],

  methods: {
    show() {
      this.$refs.dialog.show();
    }, // show()

    onOk() {
      this.hide();
    }, // onCancel()

    hide() {
      this.$emit('hide');

      if (this.$refs.dialog) {
        this.$refs.dialog.hide();
      }
    }, // hide()

    onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide');
    }, // onDialogHide()

    async onCopyActivitiesIds() {
      const activityIdsString = this.failedActivityIds.join(', ');

      if (this.$q.platform.is.capacitor) {
        await Clipboard.write({ string: activityIdsString });
      } else {
        await copyToClipboard(activityIdsString);
      }

      notifySuccess(this.$t('common.notifyCopiedToClipboard'));
    },
  },
};
</script>

<style lang="scss" scoped>
.recover-activities-dialog {
  min-width: 80vw;
}
</style>
